import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const codigosRestricciones  = {
  'bloqueadoMpd': 'bloqueado_mpd'
}

const getDefaultState = () => {
  return {
    urlcanchas: false,
    restricciones: codigosRestricciones,
  }
}

const state = getDefaultState()

const mutations = {
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
  setUrlcanchas (state, data){
    state.urlcanchas = data
  }
}

const actions = {
}
export default new Vuex.Store({
  namespaced: true,
  actions,
  state,
  mutations,
});


// WEBPACK FOOTER //
// ./src/store/index.js